"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationBusinessSolutions = void 0;
var _reactRedux = require("react-redux");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _constants = require("../../utils/constants");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import * as sec from '@vf-org/smapi-js';
var getSelectedBusinessSolution = function getSelectedBusinessSolution() {
  var selectedBusinessSolution = (0, _reactRedux.useSelector)(_recommendationSelectors.selectSelectedBusinessSolution);
  var selectedVariant = selectedBusinessSolution.selectedVariant;
  return _objectSpread(_objectSpread({}, selectedBusinessSolution), selectedVariant);
};
var getBusinessSolution = function getBusinessSolution(tier) {
  var businessSolution = (0, _reactRedux.useSelector)(function (state) {
    return (0, _recommendationSelectors.selectBusinessSolution)(state, tier);
  });
  if (!businessSolution) {
    return null;
  }
  return _objectSpread({}, businessSolution);
};
var useRecommendationBusinessSolutions = function useRecommendationBusinessSolutions() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useRecommendationSta = (0, _useRecommendationStatus.useRecommendationStatus)(),
    areBusinessSolutionsPresent = _useRecommendationSta.areBusinessSolutionsPresent;
  if (!areBusinessSolutionsPresent) {
    return {};
  }
  var recommendedBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  var premiumBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.PREMIUM);
  var budgetBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.BUDGET);
  var alternativeBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  var alternativePremiumBusinessSolution = !premiumBusinessSolution && alternativeBusinessSolution;
  var alternativeBudgetBusinessSolution = !budgetBusinessSolution && alternativeBusinessSolution;
  var selectedBusinessSolution = getSelectedBusinessSolution();
  var onBusinessSolutionSelect = function onBusinessSolutionSelect(productId) {
    dispatch((0, _recommendationActions.updateSelectedBusinessSolution)(productId));
  };
  // sec.logCustomEvent(
  //   'recommendation',
  //   `Recommended BusinessSolution: ${selectedBusinessSolution?.productName},
  //     Premium BusinessSolution: ${premiumBusinessSolution?.productName},
  //     Budget BusinessSolution: ${budgetBusinessSolution?.productName},
  //     Alt Premium BusinessSolution: ${alternativePremiumBusinessSolution?.productName},
  //     Alt Budget BusinessSolution: ${alternativeBudgetBusinessSolution?.productName},
  //     `,
  //   'recommendationPage',
  //   'recommendation BusinessSolutions',
  // );
  return {
    recommendedBusinessSolution: recommendedBusinessSolution,
    premiumBusinessSolution: premiumBusinessSolution,
    budgetBusinessSolution: budgetBusinessSolution,
    alternativePremiumBusinessSolution: alternativePremiumBusinessSolution,
    alternativeBudgetBusinessSolution: alternativeBudgetBusinessSolution,
    selectedBusinessSolution: selectedBusinessSolution,
    onBusinessSolutionSelect: onBusinessSolutionSelect
  };
};
exports.useRecommendationBusinessSolutions = useRecommendationBusinessSolutions;